
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_global.mustache";
const TPL = handlebars_family.addTemplate("filer/page_filer",{"1":function(container,depth0,helpers,partials,data) {
    return " <flexcol class=\"V4 pane-left\"></flexcol><div class=\"V4 pane-main\"></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_global"),depth0,{"name":"layout/layout_global","hash":{"addButton":"foldercreate","pageKey":"mainMenu.filer","isPageFiler":true},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;